export function parseNumber(val: string | number, fallback?: number): number {
  const d = fallback ? fallback : 0
  let v = typeof val === 'string' ? parseFloat(val) : val
  if (isNaN(v)) {
    v = d
  }
  return v
}
